import Spinner from "@atlaskit/spinner";
import type {ComponentProps} from "react";

export function AnankeSpinner(props: ComponentProps<typeof Spinner>) {
    return <Spinner {...props} />;
}
